import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/recover-account")({
	component: RecoverAccountPage,
	ssr: false,
});

function RecoverAccountPage() {
	return <AuthPage view="RECOVER_ACCOUNT" />;
}
